export const extractJsonFromText = (text:string) => {
    try {
      // Utiliser une regex pour extraire le contenu JSON
      const jsonMatch = text.match(/```json([\s\S]*?)```/);
      if (jsonMatch && jsonMatch[1]) {
        const jsonString = jsonMatch[1].trim();
        return JSON.parse(jsonString); // Convertir en objet JSON
      }
    } catch (error) {
      console.error("Erreur lors de l'extraction du JSON :", error);      
    }
    return JSON.parse(text); 
};
